/* Trendsmart - friendly inline form validation.
   Replaces the browser's native validation bubble ("Please fill out this field.")
   with on-brand, Swedish inline messages. Progressive enhancement: if this script
   does not load, native validation still works as a fallback. */
(function () {
  var MSG_REQUIRED = 'Det här fältet behöver fyllas i.';
  var MSG_EMAIL = 'Ange en giltig e-postadress.';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function wrapOf(input) {
    return input.closest('.ss-field') || input.closest('form');
  }
  function showError(input, msg) {
    input.classList.add('ss-input-invalid');
    input.setAttribute('aria-invalid', 'true');
    var wrap = wrapOf(input);
    if (!wrap) return;
    var err = wrap.querySelector('.ss-error-msg');
    if (!err) {
      err = document.createElement('span');
      err.className = 'ss-error-msg';
      err.setAttribute('aria-live', 'polite');
      wrap.appendChild(err);
    }
    err.textContent = msg;
  }
  function clearError(input) {
    input.classList.remove('ss-input-invalid');
    input.removeAttribute('aria-invalid');
    var wrap = wrapOf(input);
    if (!wrap) return;
    var err = wrap.querySelector('.ss-error-msg');
    if (err && err.parentNode) err.parentNode.removeChild(err);
  }
  function validate(input) {
    var val = (input.value || '').trim();
    if (input.hasAttribute('required') && !val) { showError(input, MSG_REQUIRED); return false; }
    if (input.type === 'email' && val && !EMAIL_RE.test(val)) { showError(input, MSG_EMAIL); return false; }
    clearError(input);
    return true;
  }
  function initForm(form) {
    form.noValidate = true;
    var fields = form.querySelectorAll('input[required], textarea[required], input[type="email"]');
    form.addEventListener('submit', function (e) {
      var ok = true, first = null;
      Array.prototype.forEach.call(fields, function (f) {
        if (!validate(f)) { ok = false; if (!first) first = f; }
      });
      if (!ok) { e.preventDefault(); if (first) first.focus(); }
    });
    Array.prototype.forEach.call(fields, function (f) {
      f.addEventListener('input', function () { if (f.classList.contains('ss-input-invalid')) validate(f); });
      f.addEventListener('blur', function () { if ((f.value || '').trim() !== '' || f.classList.contains('ss-input-invalid')) validate(f); });
    });
  }
  function init() {
    var forms = document.querySelectorAll('.ss-news-form, .ss-contact-form');
    Array.prototype.forEach.call(forms, initForm);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
